import { ChartsAxisHighlight } from "@mui/x-charts/ChartsAxisHighlight";
import { ChartsGrid } from "@mui/x-charts/ChartsGrid";
import { ChartsXAxis } from "@mui/x-charts/ChartsXAxis";
import { ChartsYAxis } from "@mui/x-charts/ChartsYAxis";
import { ChartsSurface } from "@mui/x-charts/ChartsSurface";
import { ChartsDataProvider } from "@mui/x-charts/ChartsDataProvider";
import { LinePlot, AreaPlot } from "@mui/x-charts/LineChart";
import { Box } from "@mui/material";

import DeltaAreaPlot from "./DeltaAreaPlot";
import { TimeseriesChartProps } from "./types";
import { Column } from "../containers";
import ChartsHeader from "./ChartsHeader";
import ChartsTooltip from "./ChartsTooltip";
import { useChartProps } from "./util";
import ChartsOverlay from "./ChartsOverlay";
import ChartsProjectionDefs from "./ChartsProjection";
import ChartsReferences, { ChartsReferencesLabels } from "./ChartsReferences";
import { CHART_SPACING } from "./constants";

export default function ChartContainer<T extends { date: number }>(props: TimeseriesChartProps<T>) {
    const {
        chartsDataProviderProps,
        chartsHeaderProps,
        chartsSurfaceProps,
        chartsOverlayProps,
        chartsProjectionProps,
        linePlotProps,
        areaPlotProps,
        deltaAreaPlotProps,
        xAxisProps,
        yAxisProps,
        gridProps,
        axisHighlightProps,
        chartsReferencesProps,
        chartsTooltipProps
    } = useChartProps(props);

    return (
        <Box sx={{ position: "relative", width: "100%" }}>
            <ChartsDataProvider {...chartsDataProviderProps}>
                <Column spacing={CHART_SPACING}>
                    <ChartsHeader {...chartsHeaderProps} />
                    <ChartsSurface {...chartsSurfaceProps}>
                        <ChartsOverlay {...chartsOverlayProps} />
                        <ChartsProjectionDefs {...chartsProjectionProps} />
                        <DeltaAreaPlot {...deltaAreaPlotProps} />
                        <LinePlot {...linePlotProps} />
                        <AreaPlot {...areaPlotProps} />
                        <ChartsXAxis {...xAxisProps} />
                        <ChartsGrid {...gridProps} />
                        <ChartsYAxis {...yAxisProps} />
                        <ChartsAxisHighlight {...axisHighlightProps} />
                        <ChartsReferences {...chartsReferencesProps} />
                    </ChartsSurface>
                    <ChartsReferencesLabels {...chartsReferencesProps} />
                    <ChartsTooltip {...chartsTooltipProps} />
                </Column>
            </ChartsDataProvider>
        </Box>
    );
}
